import * as fileApi from "shadow-client/endpoints/fileApi";
import * as productApi from "shadow-client/endpoints/productApi";
import { compose, lifecycle, withProps, withState } from "recompose";
import { connect } from "react-redux";
import { decodeParam } from "react-router-utils";
import { getClub, getProducts } from "shadow-client/redux/selectors";
import { withTranslator } from "app/decorators";
import ShopPage from "./ShopPage";

const mapStateToProps = (state, { productIds, clubId }) => ({
  products: getProducts(state, productIds),
  club: getClub(state, clubId)
});

function componentWillMount() {
  const { clubId, setIsLoading, fetchProductList, setProductIds, fetchFile } = this.props;

  fetchProductList({
    params: {
      context: {
        club: clubId,
        channel: "web",
        date: new Date().toISOString()
      },
      hasPublicMetadata: true
    }
  })
    .then(response => {
      const products = response["hydra:member"];
      setProductIds(products.map(product => product.get("@id")));

      const fileRequests = products
        .map(product => product.getIn(["publicMetadata", "imagePath"]))
        .filter(imagePath => imagePath.startsWith("/"))
        .map(imagePath =>
          fetchFile(imagePath, {
            headers: {
              Accept: "text/base64",
              "X-Accept-Encoding": "base64"
            }
          }).catch(error => {})
        )
        .filter(promise => promise !== undefined);

      return Promise.all(fileRequests);
    })
    .then(() => {
      setIsLoading(false);
    });
}

export default compose(
  withProps(({ match }) => ({
    clubId: decodeParam(match.params.clubId)
  })),
  connect(null, {
    fetchProductList: productApi.fetchProductList,
    fetchFile: fileApi.fetchFile
  }),
  withState("isLoading", "setIsLoading", true),
  withState("productIds", "setProductIds"),
  connect(mapStateToProps),
  lifecycle({ componentWillMount }),
  withTranslator
)(ShopPage);



// WEBPACK FOOTER //
// ./src/app/components/ShopPage/ShopPageContainer.js